import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import avatarVideo from "../../assets/bg/silent-video.webm";
import avatarVideoMp4 from "../../assets/bg/silent-video.mp4";
import manuelVideo from "../../assets/bg/silent-video-manuel.webm";
import manuelVideoMp4 from "../../assets/bg/silent-video-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario1Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const transcription = "Doctor, la verdad me siento cansado desde hace meses... Voy mucho al baño en las noches, y últimamente he notado un dolor en la espalda baja y en mi cadera derecha. Me molesta caminar o estar sentado por mucho tiempo, por lo que paso mucho tiempo acostado para evitar el dolor. Vine porque quiero saber qué me está pasando... Tengo miedo de que sea algo serio."


	const handleContinue = () => {
		navigate(ROUTES.SCENARIO1_INSTRUCTIONS);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur h-100 px-5">
						<div className="recuadro txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos mb-4">
								Presentación del caso clínico
							</h3>
							<p>Paciente masculino, 73 años</p>
							<p>Antecedentes oncológicos: negados</p>
							<p>Comorbilidades:</p>
							<ul>
								<li>Diabetes mellitus de tipo 2 de 9 años de diagnóstico en tratamiento con metformina y dapaglifozina</li>
								<li>Hipertensión arterial sistémica de 1 año de diagnóstico tratado con losartán/hidroclorotiazida</li>
								<li>Dislipidemia en tratamiento con atorvastatina</li>
								<li>ECOG 2</li>
							</ul>
							<div className="d-flex justify-content-center">
								<div className="button-escuchar-paciente mt-4 mb-4"
									onClick={abrirModal}
								>
									Escuchar al paciente
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario1Intro);
